import { siteInfo, heroStats } from '@/mocks/home';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 opacity-[0.04]" style={{
        backgroundImage: 'radial-gradient(circle at 20% 50%, oklch(0.58 0.22 22 / 0.3) 0%, transparent 50%), radial-gradient(circle at 80% 30%, oklch(0.70 0.20 77 / 0.2) 0%, transparent 50%)',
      }} />

      <div className="relative w-full max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16">
          <div className="w-full lg:w-1/2 flex flex-col items-start pt-8 md:pt-0">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-5">
              <i className="ri-fire-fill text-sm" />
              <span>2026暑期追剧季</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[3.25rem] font-heading font-bold text-foreground-950 leading-tight mb-4">
              琪琪影院
              <span className="block text-primary-500">高清追剧不缓冲</span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-xl">
              {siteInfo.description}
            </p>

            <p className="text-sm text-foreground-500 leading-relaxed mb-8 max-w-xl">
              无论是最新热播韩剧还是经典国产剧全集，琪琪影院每日同步更新，高清画质在线免费观看。从古装权谋到都市爱情，从悬疑烧脑到甜宠治愈，2000+电视剧资源等你来探索。这个夏天，让琪琪影院成为你的专属追剧伙伴。
            </p>

            <div className="flex flex-wrap items-center gap-6 mb-8">
              {heroStats.map((stat) => (
                <div key={stat.label} className="flex flex-col items-start">
                  <span className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{stat.value}</span>
                  <span className="text-xs text-foreground-500 mt-1">{stat.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap items-center gap-3">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-fill text-lg" />
                开始追剧
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 font-medium text-sm rounded-full hover:border-primary-300 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-bar-chart-fill text-lg" />
                查看热榜
              </a>
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[520px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cinematic%20collage%20of%20drama%20series%20key%20visuals%2C%20mix%20of%20Chinese%20historical%20costume%20drama%20and%20Korean%20modern%20romance%2C%20warm%20golden%20and%20crimson%20tones%2C%20dramatic%20lighting%2C%20elegant%20composition%2C%20premium%20entertainment%20brand%20feel%2C%20high%20contrast%20visual&width=1040&height=780&seq=hero-main&orientation=landscape"
                alt="琪琪影院 热门电视剧 韩剧国产剧"
                className="w-full h-full object-cover"
                title="琪琪影院 热门电视剧 韩剧国产剧"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-semibold text-primary-600">
                  热播中
                </span>
                <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs text-foreground-600">
                  每日更新
                </span>
                <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs text-foreground-600">
                  1080P高清
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}